import { FC } from "react";

export const ExplainerPoint: FC<{ point: string }> = ({ point }) => (
  <li className="text-sm text-gray-500 whitespace-normal font-regular md:text-base">
    {point}
  </li>
);
